import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import TextEditor from 'flarum/common/components/TextEditor';
import Stream from 'flarum/common/utils/Stream';
import SignatureState from '../states/SignatureState';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class Signature extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "signatureState", void 0);
    _defineProperty(this, "user", void 0);
    _defineProperty(this, "loading", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.user = vnode.attrs.user;
    this.signatureState = this.attrs.state || new SignatureState();
    this.signatureState.setContent(Stream(this.user.signature() || ''));
  }
  view() {
    return m("div", {
      className: "Signature ".concat(this.signatureState.editing ? 'editing' : '')
    }, this.loading ? m(LoadingIndicator, null) : this.signatureState.editing ? this.renderEditor() : this.renderSignature());
  }
  renderEditor() {
    if (this.user.canEditSignature() && !this.attrs.readonly) {
      return m("div", {
        class: "SignatureEditor"
      }, m(TextEditor, {
        value: this.signatureState.content(),
        onchange: this.signatureState.content,
        placeholder: app.translator.trans('signature.forum.profile.placeholder'),
        composer: this.signatureState,
        submitLabel: app.translator.trans('signature.forum.buttons.save'),
        onsubmit: this.onEditorSubmit.bind(this)
      }));
    }
  }
  onEditorSubmit() {
    this.save();
  }
  renderSignature() {
    return m("div", {
      className: "Signature-content",
      onclick: this.edit.bind(this)
    }, !this.user.signature() ? m("p", null, app.translator.trans('signature.forum.profile.click')) : m.trust(this.user.signatureHtml()));
  }
  edit() {
    if (this.user.canEditSignature() && !this.attrs.readonly) {
      this.signatureState.toggleEditing();
      m.redraw();
    }
  }
  save() {
    const signature = this.signatureState.content();
    this.loading = true;
    this.user.save({
      signature
    }).then(() => {
      this.loading = false;
      this.signatureState.setContent(Stream(signature));
      this.signatureState.toggleEditing();
      m.redraw();
    }).catch(error => {
      var _error$alert;
      this.loading = false;
      app.alerts.show({
        type: 'error'
      }, (error == null || (_error$alert = error.alert) == null ? void 0 : _error$alert.content) || app.translator.trans('signature.forum.errors.save_failed'));
      m.redraw();
    });
  }
}
flarum.reg.add('katosdev-signature', 'forum/components/Signature', Signature);